<template>
    <div>
        <modal class="ledger-detail" :display="modalStatus.ledgerDetail" @modalStatus="closeModal" >
            <h1>{{ledgerItem.houseName}}</h1>
            <div class="refund-head">
                <div class="title">
                    記帳金額
                </div>
                <div class="amount">
                    <span v-if="ledgerItem.type == 'INCOME'" class="blue">+ {{toCurrency(ledgerItem.amount)}}</span>
                    <span v-else class="red">- {{toCurrency(ledgerItem.amount)}}</span>
                </div>
            </div>
            <div class="ledger-detail-wrap">
                <div class="content">
                    <div class="list">
                        <span class="title">房源地址</span>
                        <span class="info">：{{ledgerItem.address}}</span>
                    </div>
                    <div class="list">
                        <span class="title">收支類別</span>
                        <span class="info">：{{transType(ledgerItem.type)}}</span>
                    </div>
                    <div class="list">
                        <span class="title">記帳項目</span>
                        <span class="info">：{{ledgerItem.note}}</span>
                    </div>
                    <div class="list">
                        <span class="title">記帳時間</span>
                        <span class="info">：{{ledgerItem.transactionDate}}</span>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
        }
    },
    props:{
        ledgerItem: {},
    },
    // mounted() {
    //     this.$analytics.logEvent('帳單明細', { screen_name: '帳單明細'})
    // },
    methods: {
        closeModal: function (type) {
            this.$store.dispatch('setModalStatus', {state: false, type: 'ledgerDetail'})
        },
        // toCurrency: function (num){
        //     if(num){
        //         var parts = num.toString().split('.');
        //         // console.log(parts);
        //         parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        //         return parts.join('.');
        //     }
        // },
        // transSource: function (value) {
        //     if( value == 'BOOKING_DEPOSIT' ){
        //         return '訂金'
        //     }else if( value == 'CONTRACT_DEPOSIT' ) {
        //         return '押金'
        //     }else if( value == 'CONTRACT_BILL' ) {
        //         return '帳單'
        //     }else if( value == 'HOUSE_TASK_BONUS' ) {
        //         return '委託獎金'
        //     }else if(value == 'HOUSE_LEDGER'){
        //         return '記帳'
        //     }else if(value == 'RETURN_PAID_HOUSE_TASK_BONUS'){
        //         return '委託退款'
        //     }else if(value == 'BOOKING_DEPOSIT_FOR_TENANT_REJECT'){
        //         return '取消預定'
        //     }
        // },
        // transType: function (value) {
        //     if( value == 'INCOME' ){
        //         return '收入'
        //     }else if( value == 'EXPENSE' ) {
        //         return '支出'
        //     }
        // },
        // transPayWay: function (value) {
        //     if( value == 'WALLET' ){
        //         return '飛豬錢包'
        //     }else if( value == 'TRANSFER' ) {
        //         return '匯款轉帳'
        //     }else if( value == 'TASK_REFUND' ) {
        //         return '系統退款'
        //     }else if( value == 'DEPOSIT_FORFEIT' ) {
        //         return '訂金補償'
        //     }
        // },
    },
    computed: {
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
        })
    },
    components: {
        Modal,
    }
}
</script>
<style lang="scss"  >
    #modal.ledger-detail{
        .modal-content{
            width: 488px;
            padding: 0 !important;
            .detail{
                align-items: flex-start;
                >h1{
                    width: 320px;
                    text-align: center;
                    font-size: 24px;
                    margin: 32px auto 24px;
                    line-height: 1.5;
                }
                .refund-head{
                    display: flex;
                    align-items: center;
                    width: 424px;
                    height: 72px;
                    border-radius: 8px;
                    box-shadow: 2px 2px 8px 0 rgba(41, 38, 37, 0.08);
                    border: solid 1px #f3f3f3;
                    background-color: #ffffff;
                    margin: 0 32px;
                    .title{
                        padding: 0 20px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        border-right: 1px solid #f3f3f3;
                        color: #a8a5a4;
                        height: 72px;
                    }
                    .amount{
                        padding: 0 20px;
                        font-size: 20px;
                        .red{
                            color: #ff9275;
                        }
                        .blue{
                            color: #3942b5;
                        }
                    }
                }
                .ledger-detail-wrap{
                    padding: 24px 52px;
                    .content{
                        margin-bottom: 20px;
                        .list{
                            display: flex;
                            margin-bottom: 16px;
                            .title{
                                display: block;
                                width: 56px;
                            }
                        }
                        .warm{
                            color: #fc7171;
                        }
                    }
                }
            }
      
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/widge/modal/ledgerDetail.vue